import react from "react";
import { useParams } from 'react-router-dom';
import BehindTB from "./BehindTB";
import Boden from "./Boden";
import Scimparello from "./Scimparello";
import Bottura from "./Bottura";
import Calliope from "./Calliope";
import Mirowren from "./MiroWren";
import NorthFaceMiniMe from "./NorthFaceMinime";
import WeAreShoe from "./WeAreShoe";
import Bobo from "./Bobo";
import Librino from "./Librino";
import Lozza from "./Lozza";
import NorthFace from "./NorthFace";
import Numero from "./NumeroHomme";
import Oakley from "./Oakley";
import Thatch from "./Thatch";
import Vild from "./Vild";
import UYN from "./UYN";
import CalliopeKids from "./CalliopeKids";
import CPCompanyCampaign from "./CPCompanyCampaign";
import Milk from "./Milk"
import Bash from "./Bash"
import ScotiaBank from "./ScotiaBank"
import CalliopeStudio from "./CalliopeStudio";
import RubinGlasswork from "./RubinGlasswork";
import ErnstingFamily from "./ErnstingFamily";
import CPCompanyTeens from "./CPCompanyTeens";

const CommercialsRoute = () => {
    
    // let content;
    // switch (id) {
        const { id } = useParams(); // Get the ID from the URL

        // Create a mapping of IDs to components
        const subpageComponents = {
            'm-le-monde-behind-the-bank': <BehindTB />,
            'boden': <Boden />,
            'scimparello-magazine': <Scimparello/>,
            'm-le-monde-massimo-bottura': <Bottura />,
            'calliope': <Calliope />,
            'miro-wren': <Mirowren />,
            'the-north-face-mini-me': <NorthFaceMiniMe />,
            'we-are-shoe': <WeAreShoe />,
            'bobo': <Bobo />,
            'librino-biennale': <Librino />,
            'lozza-occhiali': <Lozza />,
            'the-north-face': <NorthFace />,
            'numero-homme': <Numero />,
            'oakley': <Oakley />,
            'thatch': <Thatch />,
            'house-of-vild': <Vild />,
            'uyn-sports': <UYN/>,
            'calliope-kids': <CalliopeKids/>,
            'cp-company-ss026-kids-campaign': <CPCompanyCampaign/>,
            'milk': <Milk/>,
            'bash': <Bash/>,
            'scotia-bank': <ScotiaBank/>,
            'calliope-studio': <CalliopeStudio/>,
            'rubin-glasswork': <RubinGlasswork/>,
            'ernsting-family': <ErnstingFamily/>,
            'cp-company-teens': <CPCompanyTeens/>
        };
    
        // Render the appropriate component or a fallback if the ID is invalid
        return (
            <div className="picture-gallery">
                {subpageComponents[id] || <h1>SubPage not found</h1>}
            </div>
        );
}

export default CommercialsRoute;